module.exports = __webpack_public_path__ + "img/PRIMOR.9136560e.png";